import { createStyles, makeStyles } from '@material-ui/core';

const useGlobalStyles = makeStyles((theme) =>
    createStyles({
        // Scroll Bar
        '@global': {
            '*': {
                scrollbarColor: `${theme.palette.primary.accent} ${theme.palette.quaternary.main} !important`,
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: theme.palette.primary.accent,
                    borderRadius: 5
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: theme.palette.quaternary.main,
                },
                '&::-webkit-scrollbar': {
                    width: 9
                },
            },
            '.MuiList-root': {
                color: theme.palette.primary.main,
                background: theme.palette.quaternary.main,
                '& .Mui-selected': {
                    background: theme.palette.quaternary.accent,
                }
            },
            '.MuiAutocomplete-popper': {
                '& .MuiAutocomplete-option[aria-selected="true"]': {
                    backgroundColor: `${theme.palette.primary.accent}10 !important`
                },
                '& .Mui-checked .MuiSvgIcon-root': {
                    color: theme.palette.primary.accent
                },
                '& li': {
                    fontSize: '14px',
                    '& *': {
                        padding: 0
                    }
                },
            },
            '.Mui-checked': {
                '& svg': {
                    fill: theme.palette.primary.accent
                }
            },
            // '.MuiPaper-root': {
            //     background: `${theme.palette.quaternary.main} !important`
            // }
        },
    })
);

const GlobalStyles = () => {
    useGlobalStyles();
    return null;
};

export default GlobalStyles;